<template>
  <div class="storySlideWrapper" v-show="users.length > 0">
    <div class="landStory__container">
      <Swiper
        v-if="LoadingSkeleton"
        :slides-per-view="itemToShow"
        :dir="'rtl'"
        :rtl="true"
      >
        <SwiperSlide v-for="i in 16" :key="i">
          <div class="storyThumb">
            <div class="circle">
              <Skeletor
                v-if="LoadingSkeleton"
                class="storySkeletorImage"
                style="
                  background: rgb(163, 219, 213);
                  border-radius: 100%;
                  aspect-ratio: 1;
                "
              />
            </div>
            <div
              class="storyDesc"
              style="
                width: 100px;
                height: 31.2px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
              "
            ></div>
          </div>
        </SwiperSlide>
      </Swiper>

      <Swiper
        v-if="!LoadingSkeleton"
        :slides-per-view="itemToShow"
        :dir="'rtl'"
        :rtl="true"
      >
        <SwiperSlide v-for="(user, index) in users" :key="user.name">
          <StoryThumb :user="user" @click="() => handleThumbClick(index)" />
        </SwiperSlide>
      </Swiper>
    </div>

    <StorySlide
      v-if="isStoryOpen"
      :users="users"
      :userEdit="false"
      :userIndex="userIndex"
      :isOpen="isStoryOpen"
      :isClose="closeDialog"
      :isBackAction="isBackAction"
      :nextUser="nextUserStory"
      :prevUser="prevUserStory"
      @close="closeDialog"
      @update-back-action="(val) => (isBackAction = val)"
    />
  </div>
</template>

<script>
import StoryThumb from "@/components/StoryThumb/StoryThumb.vue";
import StorySlide from "@/components/storySlide/StorySlide.vue";
import { Skeletor } from "vue-skeletor";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import axios from "axios";

export default {
  name: "StoryComponent",

  components: {
    StoryThumb,
    StorySlide,
    Skeletor,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      userIndex: -1,
      isDragging: false,
      LoadingSkeleton: true,
      itemToShow: 14.65,
      isBackAction: false,
      carouselConfig: {
        itemsToShow: 0,
        itemsToScroll: 1,
        wrapAround: false,
      },
      users: [],
    };
  },

  computed: {
    isStoryOpen() {
      return this.$route.query.story === "active";
    },
  },

  watch: {
    isStoryOpen(open) {
      document.body.style.overflow = open ? "hidden" : "auto";
      if (!open) {
        this.userIndex = -1;
      }
    },
  },

  methods: {
    openDialog(index) {
      this.userIndex = index;
      this.$router.push({
        query: { ...this.$route.query, story: "active" },
      });
    },

    closeDialog() {
      if (!this.isBackAction) {
        const query = { ...this.$route.query };
        delete query.story;
        this.$router.push({ query });
      }
    },

    handleThumbClick(index) {
      if (this.isDragging) {
        return;
      }
      this.openDialog(index);
    },

    nextUserStory() {
      if (this.userIndex !== -1 && this.userIndex < this.users.length - 1) {
        this.userIndex += 1;
      }
    },

    prevUserStory() {
      if (this.userIndex !== 0) {
        this.userIndex -= 1;
      }
    },

    carouselConfigConfig() {
      const width = window.innerWidth;

      if (width > 1200) {
        return 14.65;
      } else if (width > 900) {
        return 10.65;
      } else if (width > 600) {
        return 6.65;
      } else {
        return 5.25;
      }
    },

    updateCarouselConfig() {
      this.carouselConfig.itemsToShow = this.carouselConfigConfig();
      this.itemToShow = this.carouselConfigConfig();
    },

    load_story() {
      axios.get(this.$store.getters.baseUrl + "/get-story").then((r) => {
        if (r.data.result == 0) {
          this.users = [];
        } else {
          this.users = r.data.data;
          console.log(r.data.data);
        }
      });
    },

    relaodPage() {
      setTimeout(() => {
        this.LoadingSkeleton = false;
      }, 200);
    },
  },

  mounted() {
    this.updateCarouselConfig();
    window.addEventListener("resize", this.updateCarouselConfig);
    this.relaodPage();
    this.load_story();
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateCarouselConfig);
  },
};
</script>

<style></style>
